import classNames from 'classnames';
import React, {ReactElement, ReactNode} from 'react';

export type SimpleCalculatorTableCell = {
  content: ReactNode;
  type?: 'input';
  borderL?: 'top' | 'bottom' | 'both' | 'middle';
  borderR?: 'top' | 'bottom' | 'both' | 'middle';
};

type Props = {
  values: SimpleCalculatorTableCell[][];
};

const SimpleCalculatorTable = ({values}: Props): ReactElement => {
  return (
    <table className={'border-separate border-spacing-0'}>
      <tbody>
        {values.map((row, idx) => (
          <tr key={idx}>
            {row.map(({content, type, borderL, borderR}, idx) => (
              <td
                key={idx}
                className={classNames(
                  'border-primary-300',
                  '[&:first-child]:font-semibold',
                  type === 'input'
                    ? 'bg-primary-500'
                    : ['px-8 py-2 [&:last-child]:w-[300px] [&:last-child]:bg-primary-100 [&:last-child]:text-right'],
                  borderL !== undefined && 'border-l-thin',
                  (borderL == 'top' || borderL === 'both') && 'border-t-thin rounded-tl-2xl',
                  (borderL == 'bottom' || borderL === 'both') && 'border-b-thin rounded-bl-2xl',
                  borderR !== undefined && 'border-r-thin',
                  (borderR == 'top' || borderR === 'both') && 'border-t-thin rounded-tr-2xl',
                  (borderR == 'bottom' || borderR === 'both') && 'border-b-thin rounded-br-2xl'
                )}
              >
                {content}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SimpleCalculatorTable;
